import { defineStyleConfig as e } from "@chakra-ui/react";
import { cssVar as r } from "@chakra-ui/theme-tools";
const o = r("tooltip-bg"), t = r("popper-arrow-bg"), p = e({
  baseStyle: {
    textStyle: "bodySmall",
    [o.variable]: "colors.gray.900",
    [t.variable]: [o.reference],
    px: 2,
    py: 2,
    bg: "gray.900",
    color: "white",
    borderRadius: "base",
    boxShadow: "lg",
    maxW: "320px",
    zIndex: "tooltip"
  }
});
export {
  p as default
};
